import { useTranslation } from 'react-i18next';
import { RenderUnsettledUI } from 'shared/components';
import { StateError } from 'shared/components/common/state/State';
import { useGetWorkerByWorkerId } from 'shared/hooks/query-hooks/use-get-worker-by-worker-id';
import { FlexWorkerLevelFilters } from 'shared/services/worker-service.types';
import { WorkerDataProviderProps } from './types';

export const WorkerDataProvider = ({
  workerId,
  children,
  verified,
  level = FlexWorkerLevelFilters.COMPLETE,
}: WorkerDataProviderProps) => {
  const { t } = useTranslation('web-common');
  const { status, error, refetch, data } = useGetWorkerByWorkerId({
    workerId: workerId ?? '',
    verified,
    level,
  });

  if (!workerId) {
    return (
      <StateError
        error={new Error(t('public-pages.worker-data-provider.error.not-found'))}
        hideNavigation
      />
    );
  }

  if (status !== 'success') {
    return (
      <RenderUnsettledUI
        data={{ status, error, refetch }}
        renderError={(queryError) => <StateError error={queryError} hideNavigation />}
      />
    );
  }

  return <>{children({ ...data, workerId })}</>;
};
